import { render, staticRenderFns } from "./staff-cardm.vue?vue&type=template&id=44e7aed8"
import script from "./staff-cardm.vue?vue&type=script&lang=ts"
export * from "./staff-cardm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports